module.exports = __webpack_public_path__ + "static/Book2-d54e6178fbb2c1442715f3134b1c95f4.jpg";